import React, { useState, useEffect, useCallback }  from "react";
import { Form } from "@components";
import { Wrapper } from "../wrapper";
import {
  Box,
  Typography,
  Grid,
  Link,
  TextField,
  Button,
} from "@material-ui/core";
import { Launch as LaunchIcon, InsertDriveFile as DriveIcon  } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { State } from "@store";
import { ConfirmationModal } from "../../confirmation-modal";

export type ThirdPartyFormValues = {
  fileId: string;
  fileUrl: string;
};
type Key = keyof ThirdPartyFormValues;
type Props = {
  onCancel: () => void;
  onSubmit: (values: ThirdPartyFormValues) => void;
  open: boolean;
  template: string | undefined;
  values: Partial<ThirdPartyFormValues>;
  readonly?: boolean;
  isViewSubmittedRequest?: boolean;
};

export const ThirdPartyForm: React.FC<Props> = ({
  onCancel,
  onSubmit,
  open,
  template,
  values,
  readonly,
  isViewSubmittedRequest,
}) => {
  const picker = React.useRef<google.picker.Picker>();
  const user = useSelector((state: State) => state.user);
  const [visible, setVisible] = React.useState(true);
  const form = Form.useManager<ThirdPartyFormValues>({
    fileId: "",
    fileUrl: "",
    ...values,
  });
  const [isConfirming, setConfirmingState] = React.useState<boolean>(false);
  const [modalMessage, setModalMessage] = React.useState<string>("");
  //console.log("env:" + process.env.NODE_ENV.toString());
  React.useEffect(() => {
    if (user && !picker.current) {
      const script = document.createElement("script");

      script.src = "https://apis.google.com/js/api.js";
      script.onload = () => {
        window.gapi.load("picker", {
          callback: () => {
            picker.current = new google.picker.PickerBuilder()
              .addView(google.picker.ViewId.DOCS)
              .addView(google.picker.ViewId.FOLDERS)
              .addView(google.picker.ViewId.SPREADSHEETS)
              .addView(new google.picker.DocsUploadView())
              .enableFeature(google.picker.Feature.MINE_ONLY)
              .enableFeature(google.picker.Feature.SUPPORT_TEAM_DRIVES)
              .setAppId("573169902390")
              .setOAuthToken(user.access_token) // current token??
              .setDeveloperKey(process.env.REACT_APP_GOOGLE_API_KEY!) // get correct key
              .build();
          },
        });
      };
      document.body.appendChild(script);
    }
  }, [user, picker]);

  function handleConfirmationConfirm() {
    onFormConfirm();
    setConfirmingState(true);
  }

  function openConfirmationModal()
  {    
    validate().then((errors) => {
      if (errors) {
        form.set(Form.target.ERRORS, errors);
      } else {
        setModalMessage("Are you sure all information is correct?");
        setConfirmingState(true);
      }
    });
  }

  function handleConfirmationCancel() {    
    closeConfirmationModal();
  }

  function closeConfirmationModal()
  {
    setModalMessage("");
    setConfirmingState(false);
  }

  function validate(
    values: Partial<ThirdPartyFormValues> = form.values
  ): Promise<any> {
    return Promise.resolve(
      Object.keys(values).reduce<any>((errors, key) => {
        switch (key) {
          case "fileId":
          case "fileUrl":
            return values[key]
              ? errors
              : {
                  ...errors,
                  [key]: "This field is required",
                };
          // case "fileUrl":
          //       console.log(Form.Validators.isURL(values[key] as string));
          //   return Form.Validators.isURL(values[key] as string)
          //     ? errors
          //     : {
          //         ...errors,
          //         [key]: "This field is required",
          //       };
          default:
            return errors;
        }
      }, null)
    );
  }
  function handleBrowseButtonClick() {
    // if (picker.current) {
    //   setVisible(false);
    //   picker.current.setCallback(({ action, docs }: any) => {
    //     if (
    //       action === google.picker.Action.CANCEL ||
    //       action === google.picker.Action.PICKED
    //     ) {
    //       setVisible(true);
    //     }
    //     if (action === google.picker.Action.PICKED) {
    //       form.set(Form.target.VALUE, ["fileId", docs[0].id]);
    //       form.set(Form.target.ERROR, ["fileId", undefined]);
    //       form.set(Form.target.VALUE, ["fileUrl", docs[0].url]);
    //       form.set(Form.target.ERROR, ["fileUrl", undefined]);
    //     }
    //   });
    //   picker.current.setVisible(true);
    // }
  }

  function onFormValueChange(name: Key, value: any): void {
   
    form.set(Form.target.VALUE, ["fileId", "1"]);
    form.set(Form.target.ERROR, ["fileId", undefined]);
    form.set(Form.target.VALUE, ["fileUrl", value]);
    form.set(Form.target.ERROR, ["fileUrl", undefined]);
  }

  function handleAttestationTextboxValueChange(
    name: "attestation",
    value: string
  ): void {
    form.set(Form.target.VALUE, ["fileId", "1"]);
    form.set(Form.target.ERROR, ["fileId", undefined]);
    form.set(Form.target.VALUE, ["fileUrl", value]);
    form.set(Form.target.ERROR, ["fileUrl", undefined]);
  }

  function onFormSubmit(): void {
    validate().then((errors) => {
      if (errors) {
        form.set(Form.target.ERRORS, errors);
      } else {
        onSubmit(form.values);
      }
    });
  }

  function onFormConfirm(): void{
    validate().then((errors) => {
      if (errors) {
        form.set(Form.target.ERRORS, errors);
      } else {
        onSubmit(form.values);
        closeConfirmationModal();
      }
    });   
    setConfirmingState(false); 
  };

  let uploadFileUrlTemplate = null;
  if (isViewSubmittedRequest) {
    uploadFileUrlTemplate = (
      <>
        <Form.Title>Form URL</Form.Title>
        <Grid item xs={12}>
          <Box color="primary" display="flex">
            <Box
              display="flex"
              alignItems="center"
              flexGrow={1}
              overflow="hidden"
              textOverflow="ellipsis"
            >
              <Typography
                noWrap
                variant="body2"
                component={Link}
                target="_blank"
                rel="noopener noreferrer"
                href={form.values.fileUrl}
                title={form.values.fileUrl}
              >
                {form.values.fileUrl}
              </Typography>
            </Box>
            <Box pl={1}>
              <LaunchIcon color="primary" />
            </Box>
          </Box>
        </Grid>
      </>
    );
  } else {
    uploadFileUrlTemplate = (
      <>
     
        <Form.Title>1. Instructions</Form.Title>
        <Grid item xs={12}>
          <Typography variant="body2">
            1. Click the link below to open the template.
          </Typography>
          <Typography variant="body2">
            2. Make a copy of the template and fill up the form.
          </Typography>
          <Typography variant="body2">
            3. Save the filled out form in personal google drive.
          </Typography>
          <Typography variant="body2">
            4. Get the URL of the filled out form and paste in the URL field below.
          </Typography>
          <Typography variant="body2" paragraph>
            5. Click "Submit".
          </Typography>
        </Grid>
        <Form.Title>2. Template copy</Form.Title>
        <Grid item xs={12}>
          <Box color="primary" display="flex">
            <Box
              display="flex"
              alignItems="center"
              flexGrow={1}
              overflow="hidden"
              textOverflow="ellipsis"
            >
              <Typography
                noWrap
                variant="body2"
                component={Link}
                target="_blank"
                rel="noopener noreferrer"
                href={template}
                title={template}
              >
                {template}
              </Typography>
            </Box>
            <Box pl={1}>
              <LaunchIcon color="primary" />
            </Box>
          </Box>
        </Grid>
        <Form.Title>3. Form URL</Form.Title>
        <Grid item xs={12}>
          <Box display="flex" alignItems="flex-end">
            <Box flexGrow={1}>
              <TextField                
                error={typeof form.errors.fileUrl === "string"}
                fullWidth
                helperText={form.errors.fileUrl}
               
                onChange={(event: any) =>
                  handleAttestationTextboxValueChange(
                    event.target.name,
                    event.target.value
                  )
                }
                
                name="fileUrl"
                required
                value={form.values.fileUrl}
              />
            </Box>
            {/* <Box ml={2}>
            <Link
                  href="https://drive.google.com/drive/my-drive"
                  target="_blank"
                >
              <Button
                variant="outlined"
                color="primary"
                endIcon={<DriveIcon />}
                onClick={handleBrowseButtonClick}
              >
                Browse
              </Button>
              </Link>
            </Box> */}
          </Box>
        </Grid>
      </>
    );
  }

  return (
    <Wrapper
      onCancel={() => {
        onCancel();
        if (values) {
          form.set(Form.target.VALUES, values);
        } else {
          form.reset();
        }
      }}
      onSubmit={openConfirmationModal}
      open={open && visible}
      title="Third Party Form"
      readonly={readonly}
    >
      <Form>{uploadFileUrlTemplate}</Form>
      <ConfirmationModal
        onCancel={handleConfirmationCancel}
        onConfirm={handleConfirmationConfirm}
        open={isConfirming}
        customMessage={modalMessage}
      />
    </Wrapper>
  );
};
